export const AUTH_ANALYTICS_EVENTS = {
  LOGIN_EMAIL_CODE_REQUESTED: 'login_email_code_requested',
  LOGIN_EMAIL_CODE_VERIFIED: 'login_email_code_verified',
  LOGIN_EMAIL_LINK_CONSUMED: 'login_email_link_consumed',
} as const;
